import {createActions} from 'client/framework';

const normalActions = ['MODIFY_ISSUE'];

export default createActions(null, normalActions);
